import axios from "axios";
import { InteractionRequiredAuthError } from "msal";
import { authProvider } from "../authProvider";
import ResultResponseModelOutput from "../models/ResultResponseModelOutput";
const {
    ACTIVE_DIRECTORY_APP_CLIENT_ID
  } = process.env;

export const refreshAccessToken = async () => {
  const user = authProvider.getAccountInfo();
  
  try {
    const token = await authProvider.acquireTokenSilent({
      scopes: ["openid", "profile", "User.Read"],
    });

    return token.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const tokenInteractionRequiredAuthError = authProvider
      .acquireTokenPopup({
        scopes: ["openid", "profile", "User.Read"]
      })
      .then((resp) => {
        return resp.accessToken;
      })
      .catch((err) => {
        return sessionStorage.getItem(`msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`);
      });

      return tokenInteractionRequiredAuthError;
    } else {
      console.error('error2', error);
      return sessionStorage.getItem(`msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`);
    }
  }
};

export const setHeaderBearerToken = async () => {
  // axios.interceptors.request.use(
  //   async (config) => {
  //     config.headers['x-api-challenge'] =
  //       localStorage.getItem('challenge') || 'no-key-found';
        
  //     const token = await refreshAccessToken();
        
  //     if (token) {
  //       config.headers['Authorization'] = `Bearer ${token}`;
  //     }
  //     return config;
  //   },
  //   (error) => Promise.reject(error)
  // );

  axios.interceptors.request.use(async (config) => {
    const acquireSilenToken = await authProvider.acquireTokenSilent({
      scopes: ["openid", "profile", "User.Read"]
    })

    
    const accessToken = sessionStorage.getItem(`msal.${ACTIVE_DIRECTORY_APP_CLIENT_ID}.idtoken`);
    
    
    config.headers = { 
      ...config.headers,
      'Authorization': `Bearer ${accessToken}`,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }

    return config;
  }, (error) => {
    
    Promise.reject(error)
  });
};

//TODO: IMPLEMENTAR REFRESH TOKEN
export const setHeaderBearerRefreshToken = async ({
}) => {
    axios.interceptors.response.use((response) => {
        return response
      }, async function (error) {
        const originalRequest = error.config;
        if (error.response.status === 403 && !originalRequest._retry) {
          originalRequest._retry = true;
          const access_token = await refreshAccessToken();
          axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
          return axios(originalRequest);
        }
        return Promise.reject(error);
      });
};

// const refreshAccessToken = async () => {
//   const user = authProvider.getAccountInfo();
//   try {
//     const token = await authProvider.acquireTokenSilent({
//       // scopes: loginRequest.scopes,
//       account: user?.account,
//     });
//     return token.accessToken;
//   } catch (error) {
//     if (error instanceof InteractionRequiredAuthError) {
//       // return authProvider
//       //   .acquireTokenPopup(loginRequest)
//       //   .then((resp) => {
//       //     return resp.accessToken;
//       //   })
//       //   .catch((err) => {
//       //     return null;
//       //   });
//     } else {
//       console.error(error);
//     }
//   }
// };

export const useInterceptor = () => {    
    let resultResponseModelOutput = new ResultResponseModelOutput();
    resultResponseModelOutput.invalid = false;
    resultResponseModelOutput.message = "";
    resultResponseModelOutput.type = "error";
        
    // axios.interceptors.response.use(function (response) {        
    //         return response;
    //     }, function (error) {   
    //             clearResultResponseModelOutput();                
    //             let responseStatus  = JSON.parse(JSON.stringify(error.response)); 
    //             let formatMessage = responseStatus.data.errors.join(" <br /> ");
    //             let statusCode = error.response.status;                
    //             switch(statusCode) {
    //                 case 400:
    //                     resultResponseModelOutput = new ResultResponseModelOutput();
    //                     resultResponseModelOutput.invalid = true;
    //                     resultResponseModelOutput.message = formatMessage;
    //                     resultResponseModelOutput.type = "info";
    //                     setResultRequestOutput(resultResponseModelOutput);  
    //                     break;
    //                 case 401:
    //                     //TODO: redirect to login ou refresh token
    //                 break;
    //                 case 500:
    //                     resultResponseModelOutput = new ResultResponseModelOutput();
    //                     resultResponseModelOutput.invalid = true;
    //                     resultResponseModelOutput.message = formatMessage;
    //                     resultResponseModelOutput.type = "error";
    //                     setResultRequestOutput(resultResponseModelOutput);
    //                 break;
    //             }                
    //     });
        
    //     const clearResultResponseModelOutput = () => {
    //         resultResponseModelOutput = new ResultResponseModelOutput();
    //         resultResponseModelOutput.invalid = false;
    //         resultResponseModelOutput.message = "";
    //         resultResponseModelOutput.type = "error";
    //         setResultRequestOutput(resultResponseModelOutput);    
    //       };

    return {               
    };
}

